export default __webpack_public_path__ + "media/images/facebook-social-cf1e7a9b214296750cec365d63b44750.svg";